import { Component, EventEmitter, computed, input, Output, forwardRef, signal, ChangeDetectionStrategy } from '@angular/core';
import { DisplayMode, SelectComponent, SelectOptionComponent } from '../select.component';
import { BaseTypeTier } from "../../../models/enums";
import { GearTierType } from '../../../models/item-data-models';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-select-gear-tier',
  imports: [FormsModule, SelectComponent, SelectOptionComponent],
  templateUrl: './select-gear-tier.component.html',
  styleUrl: './select-gear-tier.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectGearTierComponent),
      multi: true
    }
  ],
  host: {
    '[class.inline]': 'inline()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectGearTierComponent extends BaseComponent implements ControlValueAccessor {
  disabled = input<boolean>(false);
  lessThanOrEqualTo = input<boolean>(false);
  greaterThanOrEqualTo = input<boolean>(false);
  inline = input<boolean>(false);
  displayMode = computed(() => this.settings.hideIconsInDropdowns() ? 'textOnly' : 'prefixAndText');

  @Output('selectedValueChange') selectedValueChangeEmitter = new EventEmitter<BaseTypeTier | GearTierType>();

  BaseTypeTier = BaseTypeTier;

  // Internal model for ngModel binding
  internalModel = signal<BaseTypeTier | GearTierType>(BaseTypeTier.Basic);

  private onChange = (value: BaseTypeTier | GearTierType) => {};
  private onTouched = () => {};

  // ControlValueAccessor implementation
  writeValue(value: BaseTypeTier | GearTierType): void {
    this.internalModel.set(value);
  }

  registerOnChange(fn: (value: BaseTypeTier | GearTierType) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Input signals are read-only, so we can't set them directly
    // The disabled state is handled by the parent component
  }

  onModelChange(value: string | undefined) {
    if (value !== undefined) {
      const tierValue = value as BaseTypeTier | GearTierType;
      this.onChange(tierValue);
      this.onTouched();
      this.selectedValueChangeEmitter.emit(tierValue);
    }
  }
}
